import subjectPlanHeaderEn from "./locales/en.json";

export const SUBJECT_PLAN_HEADER_NS = "subjectPlanHeader" as const;

export const SubjectPlanHeaderI18n = {
  en: {
    [SUBJECT_PLAN_HEADER_NS]: {
      ...subjectPlanHeaderEn,
    },
  },
};
